module.exports = __webpack_public_path__ + "static/img/noData.cbcb7323.png";